<template>
  <div>
    <!-- ---------------------------- START MENU ---------------------------- -->
    <transition name="startMenuAnim" mode="in-out">
      <div
        v-show="startMenu"
        class="startMenu"
        @focusout="
          startMenu = false;
          settings = false;
          social = false;
        "
        tabindex="0"
        ref="strtMn"
      >
        <transition-group name="startMenuTrans" mode="in-out">
          <div
            v-show="!settings && !social"
            class="startMenuContent"
            key="strtMnCntnt"
          >
            <div class="startMenuItem settingIcon" @click="settings = true">
              Settings
            </div>
            <div class="startMenuItem socialIcon" @click="social = true">
              Social
            </div>
          </div>
          <div v-show="settings" key="sttgs">
            <div class="goBackBtn" @click="settings = false">ᐸ</div>
            <Settings />
          </div>
          <div v-show="social" key="scl">
            <div class="goBackBtn" @click="social = false">ᐸ</div>
            <div class="socialInfo">
              <p>
                You can find me on
                <span
                  @click="openLink('https://github.com/fraulk')"
                  class="aLink"
                  >github</span
                >
              </p>
              <p v-if="displayName">
                If you have any question or issue, you can send me an
                <span
                  @click="openLink('mailto:fratulker@gmail.com')"
                  class="aLink"
                  >📧</span
                >
              </p>
            </div>
          </div>
        </transition-group>
      </div>
    </transition>

    <!-- ---------------------------- TASKBAR ---------------------------- -->
    <div class="taskbar">
      <div class="leftStuff">
        <div class="startIcon" style="" @click="focusStartMenu()"></div>
        <div
          v-for="(program, i) in programList"
          @click="$emit('clicked', program)"
          :key="`${program}-${i}`"
          :class="[
            { taskbarIconExpanded: program == currentProgram },
            'taskbarIcon',
          ]"
          :style="{
            'background-image':
              'url(' + require('@/assets/' + program + '.png') + ')',
          }"
        >
          <div v-if="program == currentProgram" class="taskbarInfo">
            {{ currentProgram }}.html
          </div>
        </div>
      </div>
      <div class="rightStuff">
        <div class="time">{{ time }}</div>
        <div class="date">{{ date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Settings from "../infoComponents/Settings";

export default {
  name: "Taskbar",
  props: {
    programList: Array,
    currentProgram: String,
  },
  data: function () {
    return {
      startMenu: false,
      settings: false,
      social: false,
      date: "",
      time: "",
      displayName:
        window.location.hostname == "fratulker.netlify.app" ? true : false,
    };
  },
  created() {
    setInterval(this.getNow, 1000);
  },
  methods: {
    focusStartMenu() {
      this.startMenu = !this.startMenu;
      setTimeout(() => {
        this.$refs.strtMn.focus();
      }, 500);
    },
    getNow() {
      const today = new Date();
      const date = today.toLocaleDateString();
      const time = today.toLocaleTimeString();
      this.date = date;
      this.time = time;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
  components: {
    Settings,
  },
};
</script>

<style>
.taskbar {
  width: 100vw;
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  background-color: var(--primary-dark);
  z-index: 1;
  backdrop-filter: blur(3px);
  overflow-x: auto;
  transition: background-color 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.leftStuff {
  display: flex;
}
.rightStuff {
  display: flex;
  flex-flow: column;
  align-items: center;
  color: var(--font-color);
  font-size: 0.95rem;
  justify-content: center;
  margin-right: 10px;
}
.startMenu {
  position: absolute;
  bottom: 40px;
  width: 260px;
  height: 300px;
  overflow: hidden;
  color: rgb(238, 238, 238);
  background-color: var(--primary-dark);
  backdrop-filter: blur(5px);
  z-index: 1;
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.startMenu .aLink {
  color: white;
  border-bottom: dotted 1px white;
  cursor: pointer;
  transition: text-shadow 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}
.aLink:hover {
  text-shadow: 0px 7px 15px rgb(0, 0, 0);
}
.startMenuContent {
  position: absolute;
  bottom: 5px;
  width: 100%;
}
.startMenuItem {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 60px;
  color: rgb(238, 238, 238);
  font-size: 1.25rem;
  transition: background-color 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.95rem;
}
.startMenuItem:hover {
  background-color: var(--primary-hover);
}
.settingIcon {
  background: url("~@/assets/settingIcon.png") 3% / contain no-repeat;
}
.socialIcon {
  background: url("~@/assets/WhoAmI.png") 3% / contain no-repeat;
}
.taskbar .startIcon {
  height: 100%;
  width: 50px;
  background: url("~@/assets/WhoAmI.png") center / contain no-repeat;
  filter: grayscale(1) opacity(0.5);
  border-right: 1px solid rgb(47, 47, 47);
  transition: filter 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.taskbar .startIcon:hover {
  filter: grayscale(0) opacity(1);
  background-color: var(--primary-hover);
  border-right-color: rgba(255, 0, 51, 0);
}

.taskbar .taskbarIcon {
  height: 100%;
  width: 48px;
  max-width: 200px;
  padding-right: 1px;
  background: url("~@/assets/WhoAmI.png") center / contain no-repeat;
  transition: filter 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    width 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.taskbar .taskbarIconExpanded {
  width: 200px;
  display: flex;
  align-items: center;
  padding-left: 50px;
  background-position-x: 2%;
  background-color: var(--primary-focus);
  color: rgb(238, 238, 238);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.95rem;
}
.goBackBtn {
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background-color: var(--primary-light);
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.goBackBtn:hover {
  background-color: var(--primary-hover);
}
.taskbar .taskbarIcon:hover {
  background-color: var(--primary-hover);
}
.socialInfo {
  margin: 0 15px;
}
.startMenuAnim-enter-active {
  animation: startMenuAppear 0.2s;
}
.startMenuAnim-leave-active {
  animation: startMenuDisappear 0.2s;
}
.startMenuTrans-enter-active {
  animation: startMenuSwitchOn 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}
.startMenuTrans-leave-active {
  animation: startMenuSwitchOff 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}

@keyframes startMenuAppear {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes startMenuDisappear {
  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes startMenuSwitchOn {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  10% {
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes startMenuSwitchOff {
  80% {
    opacity: 0;
  }
  100% {
    transform: translateX(-100px);
    opacity: 0;
  }
}
</style>
